import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { IPaxConfig } from '../catalog/interfaces'
import { ITransportations, TransportationCategory } from './interfaces'

export const useState = (): DetailsState => {
  return {
    paxConfig: null,
    priceModel: undefined,
    mandatoryFlightForPriceModel: false,
    transportation: 'Individuell',
    transportations: {
      Flug: true,
      Wunschflug: false,
      Bahn: false,
      Individuell: true,
    },
    failedServiceForBooking: '',
  }
}

export interface DetailsState {
  paxConfig: IPaxConfig | null
  priceModel?: IbePriceModelCode
  mandatoryFlightForPriceModel: boolean
  transportation: TransportationCategory
  transportations: ITransportations
  failedServiceForBooking: string
}
